import React, {useEffect, useState} from "react";
/// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
/// @material-ui/icons
import People from "@material-ui/icons/People";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { useHistory } from 'react-router-dom';

import styles from "./syles";
import {
    removeCustomerChatWidget,
    resetCustomerChatSession,
} from '../CustomerChatWidget/CustomerChatWidget';
import { post, useInput } from "../../utility";

const useStyles = makeStyles(styles);

export default function Login() {

    useEffect(() => {
        void removeCustomerChatWidget();
    }, []);

    const resetError = (showError) => {
        return () => {
            if(showError) {
                setShowError(false);
            }
        }
    };

    const [ showError, setShowError ] = useState(false);
    const [ userId, setUserId ] = useInput("", resetError(showError));
    const [ password, setPassword ] = useInput("", resetError(showError));

    const classes = useStyles();

    const history = useHistory();

    const onSubmit = async () => {
        const body = JSON.stringify({
            username: userId,
            password
        });

        try {
            const response = await post('/auth', { body });

            if(response.ok) {
                const resJson = await response.json();
                const token = resJson.jwtToken;
                await resetCustomerChatSession();
                localStorage.setItem('customerPortalToken', token);
                history.push('/');
            } else {
                setShowError(true);
            }
        } catch (e) {
            setShowError(true);
        }
    };

    const onResetClicked = () => {
        history.push('/reset-password');
    };

    return (
        <div className={classes.page}>
            <section className={classes.hero}>
                <div className={classes.heroOverlay} />
                <div className={classes.brandWrap}>
                    <a href="/login" className={classes.logoLink} aria-label="Go to login page">
                        <img src="/logos/fdl.png" alt="FDL DNT" className={classes.logo} />
                    </a>
                    <span className={classes.brandText}>FDL</span>
                </div>
            </section>

            <div className={classes.loginShell}>
                <form className={classes.form}>
                    <div className={classes.cardHeader}>
                        <h1>Customer Portal</h1>
                        <p>Enter your user id and password to Sign In</p>
                    </div>
                    <div className={classes.cardBody}>
                        <div className={classes.errorContainer}>
                            { showError ? 'Incorrect user ID or password, please try again' : ''}
                        </div>
                        <CustomInput
                            labelText="User ID"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                type: "text",
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <People className={classes.inputIconsColor} />
                                    </InputAdornment>
                                ),
                                value: userId,
                                onChange: setUserId
                            }}
                        />
                        <CustomInput
                            labelText="Password"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                type: "password",
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Icon className={classes.inputIconsColor}>
                                            lock_outline
                                        </Icon>
                                    </InputAdornment>
                                ),
                                autoComplete: "off",
                                value: password,
                                onChange: setPassword
                            }}
                        />
                        <Button color="primary" className={classes.signInButton} onClick={onSubmit}>
                            Sign In
                        </Button>
                        <div className={classes.resetText}>
                            Forgot password? <button type="button" onClick={onResetClicked}>Reset Password</button>
                        </div>
                    </div>
                </form>
            </div>
            <footer className={classes.footer}>
                © 2026, made with <span>♥</span> by <strong>LongWind</strong> for a better warehouse.
            </footer>
        </div>
    );
}
